import { createBehavior } from '@area17/a17-behaviors';
import * as FocusTrap from 'focus-trap';

const filterpanels = createBehavior(
  'filterpanels',
  {
    refreshInertPanels() {
      for (const $panel of this.$panels) {
        $panel.inert = false;
      }
      setTimeout(() => {
        for (const $panel of this.$panels) {
          if ($panel !== this.$currentPanel) {
            $panel.inert = true;
          }
        }
      }, 0);
    },
    togglePanel($panel, shouldOpen) {
      $panel.classList.toggle('filterpanels:is-panel-open', shouldOpen);
      const $panelBtn = Array.from(this.$panelBtns).find(
        ($btn) => $btn.getAttribute('href') === '#' + $panel.getAttribute('id')
      );
      if ($panelBtn) {
        $panelBtn.classList.toggle('filterpanels:is-panel-open', shouldOpen);
      }
      if (shouldOpen) {
        $panel.inert = false;
        const focusTrap = FocusTrap.createFocusTrap($panel, {
          preventScroll: true,
          allowOutsideClick: true,
          onActivate: () => {},
          escapeDeactivates: () => {
            this.closeCurrentPanel();
          },
        });
        setTimeout(() => {
          focusTrap.activate();
          this.focusTrapsByPanel.set($panel, focusTrap);
        }, 0);
      } else {
        let focusTrap;
        if ((focusTrap = this.focusTrapsByPanel.get($panel))) {
          focusTrap.deactivate();
        }
        $panel.inert = true;
      }
    },
    closeCurrentPanel() {
      if (this.$currentPanel) {
        // debugger;
        this.togglePanel(this.$currentPanel, false);
        this.$currentPanel = null;
      }
    },
    onCloseBtnClick(evt) {
      evt.preventDefault();
      this.closeCurrentPanel();
    },
    onPanelBtnClick(evt) {
      evt.preventDefault();
      const id = evt.currentTarget.getAttribute('href').slice(1);
      const $chosenPanel = Array.from(this.$panels).find(
        ($panel) => $panel.getAttribute('id') === id
      );
      if ($chosenPanel) {
        if ($chosenPanel === this.$currentPanel) {
          this.closeCurrentPanel();
        } else {
          const $prevPanel = this.$currentPanel;
          this.$currentPanel = $chosenPanel;

          evt.currentTarget.classList.add('filterpanels:is-panel-open');

          if ($prevPanel) {
            this.togglePanel($prevPanel, false);
            this.animationTimeout = setTimeout(() => {
              for (const $panel of this.$panels) {
                this.togglePanel($panel, $panel === $chosenPanel);
              }
            }, this.options.duration);
          } else {
            for (const $panel of this.$panels) {
              this.togglePanel($panel, $panel === $chosenPanel);
            }
          }
        }
      }
    },
    onMessageProcessed() {
      this.refreshInertPanels();
    },
  },
  {
    init() {
      this.focusTrapsByPanel = new Map();
      this.$panelBtns = this.getChildren('panel-btn');
      this.$panels = this.getChildren('panel');
      this.$panelInners = this.getChildren('panel-inner');
      this.$closeBtns = this.getChildren('close-btn');
      this.$currentPanel = null;
      this.options.duration = this.options.duration
        ? parseInt(this.options.duration, 10)
        : 0;

      for (const $panelBtn of this.$panelBtns) {
        $panelBtn.addEventListener('click', this.onPanelBtnClick);
      }

      for (const $closeBtn of this.$closeBtns) {
        $closeBtn.addEventListener('click', this.onCloseBtnClick);
      }

      this.panelInnerObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const $content = entry.target.closest('[data-filterpanels-panel]');
          if ($content) {
            $content.style.setProperty(
              '--content-height',
              $content.scrollHeight + 'px'
            );
          }
        }
      });

      if (this.$panelInners) {
        for (const $panelInner of this.$panelInners) {
          const $content = $panelInner.closest('[data-filterpanels-panel]');
          if ($content) {
            $content.style.setProperty(
              '--content-height',
              $content.scrollHeight + 'px'
            );
          }
          this.panelInnerObserver.observe($panelInner);
        }
      }

      document.addEventListener(
        'livewire.message.processed',
        this.onMessageProcessed
      );
    },
    destroy() {
      document.removeEventListener(
        'livewire.message.processed',
        this.onMessageProcessed
      );
      if (this.$panelInners) {
        for (const $panelInner of this.$panelInners) {
          this.panelInnerObserver.unobserve($panelInner);
        }
      }
    },
  }
);

export default filterpanels;
